var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-image-preview"},[_c('img',{ref:"refImageTag",attrs:{"src":_vm.src,"alt":_vm.alt},on:{"click":_vm.gZoomImage,"load":_vm.getImageSizeFromUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }